import * as React from "react";

function Tooltip(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 23" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.75 11.5c0 6.101-4.813 11.047-10.75 11.047S.25 17.6.25 11.5C.25 5.4 5.063.454 11 .454S21.75 5.399 21.75 11.5zM12 7.39c0 .567-.446 1.027-.995 1.027h-.01c-.55 0-.995-.46-.995-1.027 0-.568.446-1.028.995-1.028h.01c.55 0 .995.46.995 1.028zm0 4.11c0-.567-.448-1.027-1-1.027s-1 .46-1 1.027v4.11c0 .568.448 1.028 1 1.028s1-.46 1-1.027V11.5z"
        fill={props.color||"#909FBA"}
      />
    </svg>
  );
}

export default Tooltip;
